import { render, staticRenderFns } from "./CaseFeatSvg.vue?vue&type=template&id=13951330"
import script from "./CaseFeatSvg.vue?vue&type=script&lang=js"
export * from "./CaseFeatSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports